import { RouteConfig } from 'vue-router'

const Index = () => import('./gelamon-invite/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/gelamon-invite-2025',
  name: 'activity_gelamon_invite_2025',
  meta: {
    title: '格里拉',
    ignoreLogin: true,
  },
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [indexRoute]
